import { baseApi } from "./base.api";

export const pageContentApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchPageContent: build.query({
      query: (page) => ({ url: `/page-content/fetch?page=${page}`, method: "GET" }),
      providesTags: (_r, _e, page) => [{ type: "PageContent", id: page }],
    }),
    savePageContent: build.mutation({
      query: (body) => ({ url: "/page-content/save", method: "POST", body }),
      invalidatesTags: (_r, _e, { page }) => [{ type: "PageContent", id: page }],
    }),
  }),
});

export const { useFetchPageContentQuery, useSavePageContentMutation } = pageContentApi;
